import './MiercuriPage.style'

import { PureComponent } from 'react'

import Html from 'Component/Html';
import ExpandableContent from 'Component/ExpandableContent';
import Link from 'Component/Link';
import Countdown from 'Component/Countdown';
import Newsletter from 'Component/Newsletter';

import isMobile from 'Util/Mobile';

class MiercuriPage extends PureComponent {

    renderTitle() {
        return <h1 block="MiercuriPage" elem="Title">{ __('Wednesday is Your Lucky Day on Farmec.eu') }</h1>
    }

    renderTimer() {
        const { isLoading, promotion: { is_active, start_date, end_date, today } } = this.props;
        const timerDate = is_active ? end_date : start_date;

        if (isLoading) {
            return (
                <div block="MiercuriPage" elem="Timer" mods={{ Loading: true }}></div>
            );
        }
        return (
            <div block="MiercuriPage" elem="Timer" mods={{ active: !!is_active }}>
                <span block="MiercuriPage" elem="TimerTitle">{ is_active ? __("The promotion is active") : __("The promotion starts in") }</span>
                <Countdown date={ timerDate } currentDate = { today } />
                <span block="MiercuriPage" elem="TimerText">{ __('Every') } <strong>{__('Wednesday and Thursday')}</strong>, {__("we bring you amazing offers. Make sure you don't miss them and sign up below")}.</span>
            </div>
        )
    }

    renderBanner() {
        const { isLoading, promotion: { is_active, banner_image, banner_image_inactive, banner_link } } = this.props;

        if (isLoading) {
            return (
                <div block="MiercuriPage" elem="Banner" mods={{ Loading: true }}></div>
            );
        }

        return (
            <div block="MiercuriPage" elem="Banner">
                { is_active
                    ? <Link to={ banner_link }><img src={ banner_image } /></Link>
                    : <img src={ banner_image_inactive } />
                }
            </div>
        )
    }

    renderNewsletter() {
        const { promotion: { is_active } } = this.props;

        return (
            <div block="MiercuriPage" elem="Newsletter">
                <div block="MiercuriPage" elem="NewsletterContent">
                    <h2>{ is_active ? __("THE PROMOTION IS ACTIVE") : __("WE’LL LET YOU KNOW WHEN THE PROMOTIONAL CAMPAIGN STARTS") }</h2>
                    <p>{ __("We bring you magical charming hours: flash promotional sales you can’t miss. By subscribing to this notification, you’ll be notified whenever there are active promotional sales on our site.") }</p>
                    <Newsletter button_text={ __('Subscribe') } source="miercuri" />
                </div>
            </div>
        )
    }

    renderConditions() {
        const { isLoading, promotion: { is_active, promotion_conditions, conditions_expanded } } = this.props;

        if (isLoading) {
            return null;
        }

        if (!is_active) {
            return null;
        }

        return (
            <div block="MiercuriPage" elem="ConditionsWrapper">
                <div block="MiercuriPage" elem="Conditions">
                    <ExpandableContent
                    heading={ __('Promotion conditions') }
                    isContentExpanded={ !!conditions_expanded }
                    mix={ {
                        block: 'MiercuriPageConditions'
                    } }
                    >
                        <Html content={ promotion_conditions } />
                    </ExpandableContent>
                </div>
            </div>
        );
    }

    renderProducts() {
        const { isLoading, promotion: { is_active, products_widget , title} } = this.props;

        if (isLoading) {
            return null;
        }

        if (!is_active) {
            return null;
        }

        return (
            <div block="MiercuriPage" elem="Products">
                <h2>{ title }</h2>
                { <Html content={ products_widget } /> }
            </div>
        )
    }

    render() {
        const { promotion: { banner_image} } = this.props;
        return (
            <main block="MiercuriPage">
                <meta name="og:image" content={banner_image}/>
                <div block="MiercuriPage" elem="Container">
                    { this.renderTitle() }
                    { this.renderTimer() }
                    <div block="MiercuriPage" elem="Cols">
                        { this.renderBanner() }
                        { !isMobile.any() && this.renderNewsletter() }
                    </div>
                </div>
                { this.renderConditions() }
                { this.renderProducts() }
                { isMobile.any() && this.renderNewsletter() }
            </main>
        )
    }

}

export default MiercuriPage
